import  { useState, useEffect } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
 import NotFound from './pages/NotFound';
 
import DonatePage from './pages/donation';
 import Response from './pages/Response';
import ValuesPage from './pages/ValuesPage';

 
 
function App() {
 
 
 
  
  return (
    <>
      <BrowserRouter>

   
        <>
        
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
             <Route path="donate" element={<DonatePage />} />
             <Route path="response" element={<Response />} />
             <Route path="values" element={<ValuesPage />} />

          <Route path="*" element={< NotFound/>} />

          </Route>
  

   
    
        </Routes>
          </>
     
      </BrowserRouter>
    </>
  );
}

export default App;
